import env from '@/lib/env'
import store from '@/lib/store'

export function jiminnyHost () {
  const region = store.get('region')

  if (region && region.name === 'EU') {
    return env('JIMINNY_HOST_EU')
  } else {
    return env('JIMINNY_HOST')
  }
}



// WEBPACK FOOTER //
// ./src/helpers/region.js